__turbopack_context__.v({
  "image": "SportTypeIcon-module-scss-module__dTEbsq__image",
  "imageVisible": "SportTypeIcon-module-scss-module__dTEbsq__imageVisible",
  "placeholder": "SportTypeIcon-module-scss-module__dTEbsq__placeholder",
  "root": "SportTypeIcon-module-scss-module__dTEbsq__root",
  "size20": "SportTypeIcon-module-scss-module__dTEbsq__size20",
  "size24": "SportTypeIcon-module-scss-module__dTEbsq__size24",
  "sportTypeIconPulse": "SportTypeIcon-module-scss-module__dTEbsq__sportTypeIconPulse",
});
